export const templateValueSeparator = `{WordTemplates}`;
